import React from "react";
import {
  Box, FormControl, Select, MenuItem, TextField, Button,
  Grid, Card, CardContent, Typography, Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // ✅ Added for navigation

const Dashboard1 = ({
  dateFilter,
  customRange,
  setDateFilter,
  setCustomRange,
  fetchDashboard,
  callSummary,
  leadSummary,
  Statusthattime
}) => {
  const navigate = useNavigate(); // ✅ Initialize navigation

  const DateFilterUI = () => (
    <Box display="flex" alignItems="center" gap={1}>
      <FormControl size="small" variant="outlined">
        <Select
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          sx={{ minWidth: 140, borderRadius: "12px" }}
        >
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="last7days">Last 7 Days</MenuItem>
          <MenuItem value="thismonth">This Month</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </Select>
      </FormControl>

      {dateFilter === "custom" && (
        <>
          <TextField
            type="date"
            size="small"
            value={customRange.from}
            onChange={(e) => setCustomRange({ ...customRange, from: e.target.value })}
            sx={{ borderRadius: "12px" }}
          />
          <TextField
            type="date"
            size="small"
            value={customRange.to}
            onChange={(e) => setCustomRange({ ...customRange, to: e.target.value })}
            sx={{ borderRadius: "12px" }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={() => fetchDashboard(sessionStorage.getItem("userId"))}
            sx={{ borderRadius: "20px", textTransform: "none", px: 3 }}
          >
            Apply
          </Button>
        </>
      )}
    </Box>
  );

  return (
    <>
      {/* Call Summary Header + Filter */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="bold">📞 Call Performance</Typography>
        <DateFilterUI />
      </Box>

      {/* Call Summary */}
      <Grid container spacing={2} mb={4}>
        {callSummary.map((item) => (
          <Grid item xs={12} sm={6} md={2.4} key={item.label}>
            <Card className="summary-card">
              <CardContent className="summary-horizontal">
                <Box className="summary-icon-left" style={{ color: item.color }}>
                  {item.icon}
                </Box>
                <Box className="summary-text-right">
                  <Typography variant="h6" fontWeight="bold">{item.value}</Typography>
                  <Typography variant="body2" color="text.secondary">{item.label}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Lead Funnel Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="bold">📊 Lead Funnel</Typography>
      </Box>

      {/* Lead Funnel */}
      <Grid container spacing={2} mb={4}>
        {leadSummary.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.label}>
            <Card className="funnel-card" style={{ borderLeft: `6px solid ${item.color}` }}>
              <CardContent>
                <Typography variant="h6" fontWeight="bold">{item.value}</Typography>
                <Typography variant="body2" color="text.secondary">{item.label}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Pending Snapshot */}
      <Typography variant="h6" fontWeight="bold" mb={2}>⏳ Pending Pipeline</Typography>
      <Grid container spacing={2} mb={4}>
        {Statusthattime.map((item) => (
          <Grid item xs={12} sm={6} md={2.4} key={item.label}>
            <Paper
              className="pending-card"
              onClick={() => {
                if (item.label === "Pen. Loan Interested") {
                  navigate("/pending-loan-interested"); // ✅ Navigate on click
                }
              }}
              sx={{ cursor: item.label === "Pen. Loan Interested" ? "pointer" : "default" }}
            >
              <Typography variant="h6" fontWeight="bold" color="primary">{item.value}</Typography>
              <Typography variant="body2">{item.label}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Dashboard1;